import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-page-wrapper" }
const _hoisted_2 = { class: "settings-card-container" }
const _hoisted_3 = { class: "settings-header-card" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = { class: "header-icon-box" }
const _hoisted_6 = { class: "header-text" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "header-right" }
const _hoisted_9 = { class: "account-type-badge" }
const _hoisted_10 = { class: "settings-form-panel" }
const _hoisted_11 = { class: "form-section-block" }
const _hoisted_12 = { class: "profile-avatar-row" }
const _hoisted_13 = { class: "avatar-uploader-box" }
const _hoisted_14 = {
  key: 0,
  class: "uploaded-avatar-wrapper"
}
const _hoisted_15 = { class: "avatar-fallback" }
const _hoisted_16 = { class: "avatar-hover-mask" }
const _hoisted_17 = {
  key: 1,
  class: "avatar-placeholder"
}
const _hoisted_18 = { class: "profile-fields" }
const _hoisted_19 = { class: "form-section-block" }
const _hoisted_20 = { class: "form-section-block" }
const _hoisted_21 = { class: "collapse-header-slot" }
const _hoisted_22 = { class: "password-fields-container" }
const _hoisted_23 = { class: "form-action-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Key = _resolveComponent("Key")!
  const _component_PictureFilled = _resolveComponent("PictureFilled")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_Check = _resolveComponent("Check")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "ambient-glow glow-1" }, null, -1)),
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "ambient-glow glow-2" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_UserFilled)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("settings.title") || "创作者个人与安全设置"), 1),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "sub-title" }, " 管理您的创作者公开档案、头像信息与账号安全凭据 ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Key)
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.form.identity || "创作者"), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          "label-position": "top",
          class: "modern-settings-form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "section-title-row" }, [
                _createElementVNode("span", { class: "indicator-bar" }),
                _createElementVNode("span", { class: "section-name" }, "基本资料与公开档案")
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    action: _ctx.UpdateApi,
                    "show-file-list": false,
                    "on-success": _ctx.handleAvatarSuccess,
                    "before-upload": _ctx.beforeAvatarUpload,
                    limit: 1,
                    "file-list": _ctx.fileList,
                    disabled: _ctx.allowUpload
                  }, {
                    default: _withCtx(() => [
                      (_ctx.imageUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_el_image, {
                              src: _ctx.imageUrl,
                              class: "avatar-img",
                              fit: "cover"
                            }, {
                              error: _withCtx(() => [
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_PictureFilled)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["src"]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("span", {
                                class: "del-icon-btn",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)), ["stop"])),
                                title: "清除并重新上传"
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Delete)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_el_icon, { class: "upload-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            }),
                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "upload-txt" }, "更换头像", -1))
                          ]))
                    ]),
                    _: 1
                  }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"]),
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "avatar-tip" }, "建议尺寸 500×500px，不超过 2MB", -1))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('settings.username') || '创作者名称',
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                        placeholder: 
                      _ctx.$t('settings.usernamePlaceholder') || '请输入创作者昵称'
                    ,
                        clearable: "",
                        size: "large",
                        "prefix-icon": _ctx.User
                      }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: "创作者身份级别",
                    prop: "identity"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.identity,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.identity) = $event)),
                        style: {"width":"100%"},
                        placeholder: "请选择",
                        disabled: "",
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "section-title-row" }, [
                _createElementVNode("span", { class: "indicator-bar" }),
                _createElementVNode("span", { class: "section-name" }, "安全通讯绑定")
              ], -1)),
              _createVNode(_component_el_form_item, {
                label: "安全邮箱地址",
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.email,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
                    disabled: "",
                    size: "large",
                    "prefix-icon": _ctx.Message
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_el_button, { class: "email-verified-btn" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_CircleCheck)
                            ]),
                            _: 1
                          }),
                          _cache[13] || (_cache[13] = _createTextVNode(" 已认证 ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "prefix-icon"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_collapse, {
                modelValue: _ctx.activeCollapse,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activeCollapse) = $event)),
                class: "modern-collapse"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse_item, { name: "change-password" }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_el_icon, { class: "lock-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Lock)
                          ]),
                          _: 1
                        }),
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "title-txt" }, "修改账号登录密码", -1)),
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "sub-txt" }, "（若无需变更密码可保持折叠）", -1))
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('settings.password') || '当前旧密码',
                          prop: "password"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "password",
                              modelValue: _ctx.form.password,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password) = $event)),
                              "show-password": "",
                              placeholder: "请输入当前生效的旧密码",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('settings.newPassword') || '设置新密码',
                          prop: "newPassword"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "password",
                              modelValue: _ctx.form.newPassword,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.newPassword) = $event)),
                              "show-password": "",
                              placeholder: "6 到 16 位字符，推荐包含字母与数字",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('settings.confirmPassword') || '再次确认新密码',
                          prop: "confirmNewPassword"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "password",
                              modelValue: _ctx.form.confirmNewPassword,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.confirmNewPassword) = $event)),
                              "show-password": "",
                              placeholder: "请再次输入新密码以确认",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_el_button, {
                class: "cancel-btn",
                size: "large",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.back(-1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("settings.back") || "取消并返回"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "save-btn",
                size: "large",
                loading: _ctx.saving,
                onClick: _ctx.handleSave
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Check)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("settings.save") || "保存设置"), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ]))
}